import React, { useState, useEffect } from 'react';
import {
    Container,
    Typography,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    TextField,
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Slider,
    Grid,
    Input,
    Button,
    useTheme,
    useMediaQuery,
    InputAdornment,
    FormHelperText,
    Checkbox,
} from '@mui/material';
import { useLocation, useHistory } from 'react-router';
import riskProfile from '../../investors/riskProfileDetails';
import { useDispatch } from 'react-redux';
import { SaveScore } from '../../../redux-store/actions/userManagement';

const InvestmentPreferenceRisk = () => {
    const [timeHorizon, setTimeHorizon] = useState('');
    const [liquidity, setLiquidity] = useState('');
    const [liquidityAmount, setLiquidityAmount] = useState('');
    const [assetSize, setAssetSize] = useState<number | ''>('');
    const [isDeclared, setIsDeclared] = useState(false);
    const history = useHistory()
    const location = useLocation<any>();
    const UserData = location.state?.UserData;
    const UserRiskProfilePayload = location.state?.riskProfilePayload;
    const riskProfileData = location.state?.riskProfileData;
    const dispatch = useDispatch()

    console.log(UserData)
    console.log(UserRiskProfilePayload)

    const [assetAllocation, setAssetAllocation] = useState({
        fixedIncome: { min: 0, max: 0 },
        equity: { min: 0, max: 0 },
        alternates: { min: 0, max: 0 },
        commoditiesAndPreciousMetals: { min: 0, max: 0 }
    });

    const [fixedIncomeMaturities, setFixedIncomeMaturities] = useState({
        'less Than 1 Year': 0,
        '1 Year To 3 Years': 0,
        'above 3 Years': 0,
    });

    const [isOptedOut, setIsOptedOut] = useState(false);

    const [fixedIncomeCategories, setFixedIncomeCategories] = useState({
        creditRatingAAAOrAbove: 0,
        creditRatingAAAOrBelow: 0,
    });

    const [errors, setErrors] = useState({
        timeHorizon: '',
        liquidity: '',
        liquidityAmount: '',
        assetSize: '',
    });

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const LOCAL_STORAGE_KEY = 'investmentPreferenceProgress';

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const savedData = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (savedData) {
            const data = JSON.parse(savedData);
            setTimeHorizon(data.timeHorizon || '');
            setLiquidity(data.liquidity || '');
            setLiquidityAmount(data.liquidityAmount || '');
            setAssetSize(data.assetSize || '');
            setAssetAllocation(data.assetAllocation || {
                fixedIncome: { min: 0, max: 0 },
                equity: { min: 0, max: 0 },
                alternates: { min: 0, max: 0 },
                commoditiesAndPreciousMetals: { min: 0, max: 0 }
            });
            setFixedIncomeMaturities(data.fixedIncomeMaturities || {
                'less Than 1 Year': 0,
                '1 Year To 3 Years': 0,
                'above 3 Years': 0,
            });
            setFixedIncomeCategories(data.fixedIncomeCategories || {
                creditRatingAAAOrAbove: 0,
                creditRatingAAAOrBelow: 0,
            });
            setIsOptedOut(data.isOptedOut || false);
            setIsDeclared(data.isDeclared || false);
        }
    }, []);

    useEffect(() => {
        const dataToSave = {
            timeHorizon,
            liquidity,
            liquidityAmount,
            assetSize,
            assetAllocation,
            fixedIncomeMaturities,
            fixedIncomeCategories,
            isOptedOut,
            isDeclared,
        };
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(dataToSave));
    }, [
        timeHorizon,
        liquidity,
        liquidityAmount,
        assetSize,
        assetAllocation,
        fixedIncomeMaturities,
        fixedIncomeCategories,
        isOptedOut,
        isDeclared,
    ]);

    useEffect(() => {
        const updatedAllocation = { ...assetAllocation };
        let changed = false;
        for (const key in updatedAllocation) {
            const assetClass = key as keyof typeof assetAllocation;
            if (updatedAllocation[assetClass].max < updatedAllocation[assetClass].min) {
                updatedAllocation[assetClass].max = updatedAllocation[assetClass].min;
                changed = true;
            }
        }
        if (changed) {
            setAssetAllocation(updatedAllocation);
        }
    }, [assetAllocation]);



    const validate = () => {
        const tempErrors = { timeHorizon: '', liquidity: '', liquidityAmount: '', assetSize: '' };
        let isValid = true;

        if (!timeHorizon) {
            tempErrors.timeHorizon = 'Time Horizon is required.';
            isValid = false;
        }
        if (!liquidity) {
            tempErrors.liquidity = 'Liquidity selection is required.';
            isValid = false;
        }
        if (liquidity === 'yes' && !liquidityAmount) {
            tempErrors.liquidityAmount = 'Anticipated amount is required.';
            isValid = false;
        }
        if (assetSize === '' || assetSize === null) {
            tempErrors.assetSize = 'Indicative Asset Size is required.';
            isValid = false;
        }

        setErrors(tempErrors);
        return isValid;
    };

    useEffect(() => {
        if (isOptedOut) {
            setIsDeclared(false);
        }
    }, [isOptedOut]);

    const handleBack = () => {
        history.push("/investor-risk-profiledetails", { UserData });
    };

    const handleProceed = async () => {
        const proceed = async () => {
            const investmentPreferenceData = {
                isOptedOut: isOptedOut,
                preferences: isOptedOut ? null : {
                    timeHorizon: timeHorizon,
                    liquidity: {
                        isRequired: liquidity === 'yes',
                        anticipatedAmount: liquidityAmount,
                    },
                    indicativeAssetSize: assetSize,
                    assetAllocationGuidelines: assetAllocation,
                    fixedIncomeMaturityLimits: fixedIncomeMaturities,
                    fixedIncomeCategoryTolerances: fixedIncomeCategories,
                }
            };

            const completionPayload = {
                userData: UserData,
                riskProfilePayload: UserRiskProfilePayload,
                investmentPreferenceData: investmentPreferenceData,
                riskProfileData: riskProfileData,
            };
            console.log(completionPayload)

            const response = await dispatch(SaveScore(completionPayload)) as unknown as any;
            console.log(response)
            const errorCode = response?.[0]?.[0]?.ErrorCode;
            if (errorCode === 0) {
                console.log('Payload saved successfully');
                history.push('/completion-page', { completionPayload });
            } else {
                console.error('Failed to save payload:', response);
                alert('Failed to save payload')
                return;
            }

        };

        if (isOptedOut) {
            await proceed();
        } else {
            if (validate()) {
                console.log('Form submitted successfully');
                await proceed();
            } else {
                console.log('Form has errors');
            }
        }
    };

    const handleSliderChange = (
        assetClass: keyof typeof assetAllocation,
        which: 'min' | 'max'
    ) => (event: Event, newValue: number | number[]) => {
        setAssetAllocation((prev) => ({
            ...prev,
            [assetClass]: { ...prev[assetClass], [which]: newValue as number },
        }));
    };

    const handleInputChange = (
        assetClass: keyof typeof assetAllocation,
        which: 'min' | 'max'
    ) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (/^\d*$/.test(value)) {
            let numericValue = value === '' ? '' : Number(value);
            if (typeof numericValue === 'number' && numericValue > 100) {
                numericValue = 100;
            }
            setAssetAllocation((prev) => ({
                ...prev,
                [assetClass]: { ...prev[assetClass], [which]: numericValue },
            }));
        }
    };

    const handleBlur = (
        assetClass: keyof typeof assetAllocation,
        which: 'min' | 'max'
    ) => () => {
        let value = assetAllocation[assetClass][which];
        if (value < 0) {
            value = 0;
        } else if (value > 100) {
            value = 100;
        }
        setAssetAllocation((prev) => ({
            ...prev,
            [assetClass]: { ...prev[assetClass], [which]: value },
        }));
    };

    const handleFixedIncomeMaturitySliderChange = (
        bucket: keyof typeof fixedIncomeMaturities
    ) => (event: Event, newValue: number | number[]) => {
        setFixedIncomeMaturities((prev) => ({
            ...prev,
            [bucket]: newValue as number,
        }));
    };

    const handleFixedIncomeMaturityInputChange = (
        bucket: keyof typeof fixedIncomeMaturities
    ) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (/^\d*$/.test(value)) {
            let numericValue = value === '' ? 0 : Number(value);
            if (numericValue > 100) {
                numericValue = 100;
            }
            setFixedIncomeMaturities((prev) => ({
                ...prev,
                [bucket]: numericValue,
            }));
        }
    };

    const handleFixedIncomeMaturityBlur = (
        bucket: keyof typeof fixedIncomeMaturities
    ) => () => {
        let value = fixedIncomeMaturities[bucket];
        if (value < 0) {
            value = 0;
        } else if (value > 100) {
            value = 100;
        }
        setFixedIncomeMaturities((prev) => ({
            ...prev,
            [bucket]: value,
        }));
    };

    const handleFixedIncomeCategorySliderChange = (
        category: keyof typeof fixedIncomeCategories
    ) => (event: Event, newValue: number | number[]) => {
        setFixedIncomeCategories((prev) => ({
            ...prev,
            [category]: newValue as number,
        }));
    };

    const handleFixedIncomeCategoryInputChange = (
        category: keyof typeof fixedIncomeCategories
    ) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (/^\d*$/.test(value)) {
            let numericValue = value === '' ? 0 : Number(value);
            if (numericValue > 100) {
                numericValue = 100;
            }
            setFixedIncomeCategories((prev) => ({
                ...prev,
                [category]: numericValue,
            }));
        }
    };

    const handleFixedIncomeCategoryBlur = (
        category: keyof typeof fixedIncomeCategories
    ) => () => {
        let value = fixedIncomeCategories[category];
        if (value < 0) {
            value = 0;
        } else if (value > 100) {
            value = 100;
        }
        setFixedIncomeCategories((prev) => ({
            ...prev,
            [category]: value,
        }));
    };

    const formatAssetClassName = (name: string) => {
        return name
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, (str) => str.toUpperCase());
    };

    return (
        <Box sx={{ width: '100%', backgroundColor: '#f8fbfd', py: 4 }}>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="100vh"
                p={isMobile ? 2 : 4}
            >
                <Container maxWidth="md">

                    <Paper elevation={3} sx={{ p: isMobile ? 3 : 4, borderRadius: 2 }}>


                        <Box sx={{ textAlign: 'left', mb: 4 }}>
                            <Typography variant="h4" component="h1" gutterBottom>
                                Investment Policy Statement
                            </Typography>
                        </Box>

                        <FormControlLabel
                            control={<Checkbox checked={isOptedOut} onChange={(e) => setIsOptedOut(e.target.checked)} />}
                            label="I do not wish to provide investment policy statement and want to use the platform of products and services as an execution-only platform, whereby all investment decisions would be my sole discretion and decision"
                            sx={{ mb: 3, display: 'flex', alignItems: 'flex-start' }}
                        />

                        <Box sx={{ pointerEvents: isOptedOut ? 'none' : 'auto', opacity: isOptedOut ? 0.5 : 1 }}>

                            <Box my={5}>
                                <FormControl component="fieldset" fullWidth error={!!errors.timeHorizon}>
                                    <FormLabel
                                        component="legend"
                                        sx={{
                                            mb: 2,
                                            fontWeight: 'bold',
                                            fontSize: '1.1rem',
                                            color: 'primary.main'
                                        }}
                                    >
                                        1. Time Horizon
                                    </FormLabel>

                                    <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>
                                        Please indicate the expected tenure of the investment.<span style={{ color: 'red' }}> *</span>
                                    </Typography>
                                    <RadioGroup
                                        aria-label="time-horizon"
                                        name="time-horizon"
                                        value={timeHorizon}
                                        onChange={(e) => setTimeHorizon(e.target.value)}
                                    >
                                        <FormControlLabel
                                            value="less-than-1-year"
                                            control={<Radio />}
                                            label="Less Than 1 Year"
                                        />
                                        <FormControlLabel
                                            value="1-to-5-years"
                                            control={<Radio />}
                                            label="Between 1 year to 5 years"
                                        />
                                        <FormControlLabel
                                            value="more-than-5-years"
                                            control={<Radio />}
                                            label="More than 5 years"
                                        />
                                    </RadioGroup>
                                    {errors.timeHorizon && <FormHelperText>{errors.timeHorizon}</FormHelperText>}
                                </FormControl>
                            </Box>

                            <Box my={5}>
                                <FormControl component="fieldset" fullWidth error={!!errors.liquidity}>
                                    <FormLabel component="legend"
                                        sx={{
                                            mb: 2,
                                            fontWeight: 'bold',
                                            fontSize: '1.1rem',
                                            color: 'primary.main'
                                        }}>
                                        2. Liquidity
                                    </FormLabel>
                                    <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>
                                        Do you anticipate having to liquidate assets under advice within the next 3 years to fund other financial commitments?<span style={{ color: 'red' }}> *</span>
                                    </Typography>
                                    <RadioGroup
                                        aria-label="liquidity"
                                        name="liquidity"
                                        value={liquidity}
                                        onChange={(e) => setLiquidity(e.target.value)}
                                    >
                                        <FormControlLabel value="no" control={<Radio />} label="No" />
                                        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                    </RadioGroup>
                                    {errors.liquidity && <FormHelperText>{errors.liquidity}</FormHelperText>}
                                    {liquidity === 'yes' && (
                                        <TextField
                                            label="Anticipated Amount (INR)"
                                            variant="outlined"
                                            type="text"
                                            inputMode="numeric"
                                            value={liquidityAmount}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*$/.test(value)) {
                                                    setLiquidityAmount(value);
                                                }
                                            }}
                                            fullWidth
                                            margin="normal"
                                            sx={{ mt: 2 }}
                                            error={!!errors.liquidityAmount}
                                            helperText={errors.liquidityAmount}
                                        />
                                    )}
                                </FormControl>
                            </Box>

                            <Box my={5}>
                                <Typography
                                    gutterBottom
                                    fontWeight="bold"
                                    sx={{ fontSize: '1.1rem', color: 'primary.main', mb: 3 }}
                                >
                                    3. Indicative Asset Size (INR)<span style={{ color: 'red' }}> *</span>
                                </Typography>


                                <TextField
                                    label="Enter Amount"
                                    variant="outlined"
                                    type="text"
                                    inputMode="numeric"
                                    value={assetSize}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value)) {
                                            setAssetSize(value === '' ? '' : Number(value));
                                        }
                                    }}
                                    sx={{ width: isMobile ? '100%' : '50%' }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                    }}

                                    error={!!errors.assetSize}
                                    helperText={errors.assetSize}
                                />
                            </Box>

                            <Box my={4}>
                                <Typography
                                    gutterBottom
                                    fontWeight="bold"
                                    sx={{ fontSize: '1.1rem', color: 'primary.main', mb: 3 }}
                                >
                                    4. Asset Allocation Guidelines
                                </Typography>
                                <Typography variant="body2" color="textSecondary" gutterBottom>
                                    Please indicate the broad asset allocation guidelines to be implemented for the investment advice.<span style={{ color: 'red' }}> *</span>
                                </Typography>
                                <TableContainer component={Paper} variant="outlined" sx={{ mt: 2, overflowX: 'auto' }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                                                    Asset Class*
                                                </TableCell>
                                                <TableCell align="center" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                                                    Minimum Allocation %
                                                </TableCell>
                                                <TableCell align="center" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                                                    Maximum Allocation %
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {Object.keys(assetAllocation).map((assetClass) => (
                                                <TableRow key={assetClass}>
                                                    <TableCell component="th" scope="row">
                                                        {formatAssetClassName(assetClass)}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Grid container spacing={2} alignItems="center">
                                                            <Grid item xs>
                                                                <Slider
                                                                    value={assetAllocation[assetClass as keyof typeof assetAllocation].min}
                                                                    onChange={handleSliderChange(assetClass as keyof typeof assetAllocation, 'min')}
                                                                    aria-labelledby={`${assetClass}-min-slider`}
                                                                />
                                                            </Grid>
                                                            <Grid item>
                                                                <Input
                                                                    value={assetAllocation[assetClass as keyof typeof assetAllocation].min}
                                                                    size="small"
                                                                    onChange={handleInputChange(assetClass as keyof typeof assetAllocation, 'min')}
                                                                    onBlur={handleBlur(assetClass as keyof typeof assetAllocation, 'min')}
                                                                    inputProps={{
                                                                        step: 1,
                                                                        min: 0,
                                                                        max: 100,
                                                                        type: 'text',
                                                                        inputMode: 'numeric',
                                                                        'aria-labelledby': `${assetClass}-min-slider`,
                                                                    }}
                                                                    sx={{ width: 60 }}
                                                                /> %
                                                            </Grid>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Grid container spacing={2} alignItems="center">
                                                            <Grid item xs>
                                                                <Slider
                                                                    value={assetAllocation[assetClass as keyof typeof assetAllocation].max}
                                                                    onChange={handleSliderChange(assetClass as keyof typeof assetAllocation, 'max')}
                                                                    aria-labelledby={`${assetClass}-max-slider`}
                                                                />
                                                            </Grid>
                                                            <Grid item>
                                                                <Input
                                                                    value={assetAllocation[assetClass as keyof typeof assetAllocation].max}
                                                                    size="small"
                                                                    onChange={handleInputChange(assetClass as keyof typeof assetAllocation, 'max')}
                                                                    onBlur={handleBlur(assetClass as keyof typeof assetAllocation, 'max')}
                                                                    inputProps={{
                                                                        step: 1,
                                                                        min: 0,
                                                                        max: 100,
                                                                        type: 'text',
                                                                        inputMode: 'numeric',
                                                                        'aria-labelledby': `${assetClass}-max-slider`
                                                                    }}
                                                                    sx={{ width: 60 }}
                                                                /> %
                                                            </Grid>
                                                        </Grid>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Box mt={2}>
                                    <Typography variant="caption" display="block" gutterBottom>
                                        *A tolerance limit of +/-10% to be followed
                                    </Typography>
                                    <Typography variant="caption" display="block">
                                        *Maximum Allocation % should greater than Minimum Allocation % (else value will adjust to Minimum Allocation %)
                                    </Typography>
                                </Box>
                            </Box>

                            <Box my={5}>
                                <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ fontSize: '1.1rem', color: 'primary.main', mb: 3 }}>
                                    5. Allocation limit for the below Fixed income maturities<span style={{ color: 'red' }}> *</span>
                                </Typography>

                                {/* This is the key component for responsiveness */}
                                <TableContainer component={Paper} variant="outlined" sx={{ mt: 2, overflowX: 'auto' }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Maturity Buckets</TableCell>
                                                <TableCell align="center" sx={{ fontWeight: 'bold', color: 'primary.main' }}>Indicative Allocation</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Object.keys(fixedIncomeMaturities).map((bucket) => (
                                                <TableRow key={bucket}>
                                                    <TableCell component="th" scope="row">
                                                        {bucket.replace(/([A-Z])/g, ' $1').replace('To', ' to ').replace('Year', ' Year')}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Grid container spacing={2} alignItems="center">
                                                            <Grid item xs>
                                                                <Slider
                                                                    value={fixedIncomeMaturities[bucket as keyof typeof fixedIncomeMaturities]}
                                                                    onChange={handleFixedIncomeMaturitySliderChange(bucket as keyof typeof fixedIncomeMaturities)}
                                                                    aria-labelledby={`${bucket}-slider`}
                                                                />
                                                            </Grid>
                                                            <Grid item>
                                                                <Input
                                                                    value={fixedIncomeMaturities[bucket as keyof typeof fixedIncomeMaturities]}
                                                                    size="small"
                                                                    onChange={handleFixedIncomeMaturityInputChange(bucket as keyof typeof fixedIncomeMaturities)}
                                                                    onBlur={handleFixedIncomeMaturityBlur(bucket as keyof typeof fixedIncomeMaturities)}
                                                                    inputProps={{
                                                                        step: 1,
                                                                        min: 0,
                                                                        max: 100,
                                                                        type: 'text',
                                                                        inputMode: 'numeric',
                                                                        'aria-labelledby': `${bucket}-slider`,
                                                                    }}
                                                                    sx={{ width: 60 }}
                                                                /> %
                                                            </Grid>
                                                        </Grid>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <Box mt={2}>
                                    <Typography variant="caption" display="block" gutterBottom>
                                        *Market capitalisation guidelines as per SEBI & AMFI
                                    </Typography>
                                    <Typography variant="caption" display="block">
                                        **A tolerance limit of +/-10% to be followed
                                    </Typography>
                                </Box>
                            </Box>

                            <Box my={5}>
                                <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ fontSize: '1.1rem', color: 'primary.main', mb: 3 }}>
                                    6. Tolerance limits for the below Fixed Income categories<span style={{ color: 'red' }}> *</span>
                                </Typography>
                                <TableContainer component={Paper} variant="outlined" sx={{ mt: 2, overflowX: 'auto' }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Fixed Income Category*</TableCell>
                                                <TableCell align="center" sx={{ fontWeight: 'bold', color: 'primary.main' }}>Allocation %</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Object.keys(fixedIncomeCategories).map((category) => (
                                                <TableRow key={category}>
                                                    <TableCell component="th" scope="row">
                                                        {category === 'creditRatingAAAOrAbove' ? 'Credit Rating - AAA or above' : 'Credit Rating - AA or below'}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Grid container spacing={2} alignItems="center">
                                                            <Grid item xs>
                                                                <Slider
                                                                    value={fixedIncomeCategories[category as keyof typeof fixedIncomeCategories]}
                                                                    onChange={handleFixedIncomeCategorySliderChange(category as keyof typeof fixedIncomeCategories)}
                                                                    aria-labelledby={`${category}-slider`}
                                                                />
                                                            </Grid>
                                                            <Grid item>
                                                                <Input
                                                                    value={fixedIncomeCategories[category as keyof typeof fixedIncomeCategories]}
                                                                    size="small"
                                                                    onChange={handleFixedIncomeCategoryInputChange(category as keyof typeof fixedIncomeCategories)}
                                                                    onBlur={handleFixedIncomeCategoryBlur(category as keyof typeof fixedIncomeCategories)}
                                                                    inputProps={{
                                                                        step: 1,
                                                                        min: 0,
                                                                        max: 100,
                                                                        type: 'text',
                                                                        inputMode: 'numeric',
                                                                        'aria-labelledby': `${category}-slider`,
                                                                    }}
                                                                    sx={{ width: 60 }}
                                                                /> %
                                                            </Grid>
                                                        </Grid>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Box>

                        <Box sx={{ pointerEvents: isOptedOut ? 'none' : 'auto', opacity: isOptedOut ? 0.5 : 1, mt: 4 }}>
                            <FormControlLabel
                                control={<Checkbox checked={isDeclared} onChange={(e) => setIsDeclared(e.target.checked)} disabled={isOptedOut} />}
                                label="I hereby declare that the information provided by me in this form is true, correct, and complete to the best of my knowledge and I undertake to inform you of any changes therein, immediately. In case any of the above information is found to be false or untrue or misleading or misrepresenting, I am aware that I may be held liable for it."
                                sx={{ display: 'flex', alignItems: 'flex-start' }}
                            />
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4, gap: 2 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                onClick={handleBack}
                            >
                                Back
                            </Button>

                            <Button variant="contained" color="primary" size="large" onClick={handleProceed} disabled={!isOptedOut && !isDeclared}>
                                Proceed
                            </Button>
                        </Box>
                    </Paper>
                </Container>
            </Box>
        </Box>
    );
};

export default InvestmentPreferenceRisk;